import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
    }, []);
    return (
        <div data-testid="blog-page">
            <section className="mx-auto max-w-6xl px-6 md:px-12 py-28">
                <div className="label-tag">The Journal</div>
                <h1 className="mt-4 font-display text-5xl md:text-6xl font-black tracking-tight">
                    Field notes from the fight.
                </h1>
                <p className="mt-6 text-white/70 max-w-2xl text-lg">
                    Essays, playbooks, and case teardowns from our practice. Written for
                    stewards, business reps, and officers.
                </p>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
                    {posts.map((p) => (
                        <Link
                            key={p.slug}
                            to={`/blog/${p.slug}`}
                            data-testid={`blog-card-${p.slug}`}
                            className="group rounded-2xl overflow-hidden bg-ink-800 border border-white/10 gold-glow transition-all"
                        >
                            <div className="h-56 overflow-hidden">
                                <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                            </div>
                            <div className="p-8">
                                <div className="flex gap-2 mb-3 flex-wrap">
                                    {(p.tags || []).map((t) => (
                                        <span key={t} className="text-[10px] tracking-[0.2em] uppercase text-gold-500 border border-gold-500/40 rounded-full px-2 py-0.5">
                                            {t}
                                        </span>
                                    ))}
                                </div>
                                <h2 className="font-display text-2xl font-bold leading-snug group-hover:text-gold-500 transition-colors">
                                    {p.title}
                                </h2>
                                <p className="mt-3 text-sm text-white/60 line-clamp-3">{p.excerpt}</p>
                                <p className="mt-5 text-xs uppercase tracking-[0.25em] text-gold-500">
                                    Read article →
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
